export default "__VITE_ASSET__aZ0nenzD__"